export default __webpack_public_path__ + "static/char-v-53-cc8390be9bc5943dee2c3670c7ae45bc.png";